import React from 'react';
import styles from './index.module.scss';
import ContentLoader from 'react-content-loader';

function OfferCardLoader() {
  return (
    <div
      className={styles.offerCard}
      style={{
        padding: 0,
      }}
    >
      <div
        className={styles.left}
        style={{
          padding: 0,
        }}
      >
        <ContentLoader
          speed={2}
          backgroundColor="#1C2B5A"
          foregroundColor="#162143"
          width={`calc(100% - 32px)`}
          height={90}
          style={{
            padding: 0,
          }}
        >
          <rect x="20" y="16" rx="2" ry="2" width="40" height="40" />
          <rect x="10" y="60" rx="2" ry="2" width="62px" height="20" />
        </ContentLoader>
      </div>
      <div
        className={styles.right}
        style={{
          padding: 0,
        }}
      >
        <ContentLoader
          speed={2}
          backgroundColor="#1C2B5A"
          foregroundColor="#162143"
          width={`calc(100% - 32px)`}
          height={90}
          style={{
            padding: 0,
          }}
        >
          <rect x="20" y="10" rx="2" ry="2" width="60%" height="20" />
          <rect x="20" y="35" rx="2" ry="2" width="100%" height="20" />
          <rect x="20" y="60" rx="2" ry="2" width="80%" height="20" />
        </ContentLoader>
      </div>
    </div>
  );
}

export default OfferCardLoader;
